module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/transportation-unit-lvl2-50.f5e6c5b8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/transportation-unit-lvl2-50.png
// module id = 3574
// module chunks = 11